export const adjustHeight = (element: HTMLTextAreaElement) => {
  const elementHeight = 'auto';
  const elementStyle = element.style;

  elementStyle.height = elementHeight;
  const { scrollHeight } = element;

  elementStyle.overflowY = 'hidden';
  elementStyle.height = `${scrollHeight}px`;
};
